import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';

import TextQuestion from 'ui_system/questions/text';
import MultiSelectQuestion from 'ui_system/questions/multiselect';
import SelectQuestion from 'ui_system/questions/select';
import RadioQuestion from 'ui_system/questions/radio';

import { Label, SubLabel, Section, LabelBox } from '../../styles';

const { object, number, string } = PropTypes;

const FeedbackQuestion = ({
  question,
  i18n,
  color,
  bookingId,
  experienceQuestionId,
  guestId,
}) => {
  const { attributes } = question;
  const { textTranslations, subtextTranslations } = attributes;
  let questionComponent;

  switch (attributes.inputType) {
    case 'radio':
      questionComponent = RadioQuestion;
      break;
    case 'select':
      questionComponent = SelectQuestion;
      break;
    case 'multi':
      questionComponent = MultiSelectQuestion;
      break;
    case 'text':
      questionComponent = TextQuestion;
      break;
    // no default
  }

  const answerOptions = attributes.options.data.map((option) => {
    const label =
      option.attributes.textTranslations[i18n] ||
      option.attributes.textTranslations['en-US'];
    return {
      value: option.attributes.id,
      label,
    };
  });

  const text = textTranslations[i18n] || textTranslations['en-US'];
  const subText = subtextTranslations[i18n] || subtextTranslations['en-US'];

  return (
    <Section className={`row ${question.input_type}`}>
      <LabelBox>
        <Label>{text}</Label>
        <SubLabel>{subText}</SubLabel>
      </LabelBox>
      <Field
        name={`feedbackQuestion${experienceQuestionId}`}
        fieldName={`feedbackQuestion${experienceQuestionId}`}
        component={questionComponent}
        answerOptions={answerOptions}
        experienceQuestionId={experienceQuestionId}
        color={color}
        bookingId={bookingId}
        guestId={guestId}
      />
    </Section>
  );
};

FeedbackQuestion.propTypes = {
  question: object.isRequired,
  i18n: string.isRequired,
  bookingId: number.isRequired,
  experienceQuestionId: number.isRequired,
};

export default FeedbackQuestion;
